// A `set` of null erases the key. The web passes localStorage, the app its own storage;
// neither shape is assumed, which is what keeps this module out of the DOM.
export interface KeyValueStore {
  get(key: string): string | null
  set(key: string, value: string | null): void
}

export function readStored(store: KeyValueStore | null, key: string): string | null {
  try {
    return store?.get(key) ?? null
  } catch {
    return null
  }
}

export function writeStored(store: KeyValueStore | null, key: string, value: string | null): void {
  try {
    store?.set(key, value)
  } catch {}
}
